import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "location-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "offset-md-1 col-12 col-md-10 mb-4 mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Bestellung Abgeschlossen", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Ihre Reservierung wurde erfolgreich abgeschlossen und Ihre Kennzeichen werden spätestens morgen versendet. In wenigen Minuten erhalten Sie zudem eine E-Mail mit einer Zusammenfassung Ihrer Bestellung. ", -1)
const _hoisted_7 = { class: "d-flex justify-content-center mb-0 mt-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Zur Startseite ")
const _hoisted_9 = { class: "pb-1" }
const _hoisted_10 = { class: "container" }

import { useRouter } from 'vue-router';

// vue components
import StepHeader from '@/components/StepHeader.vue';
import StepBox from '@/components/StepBox.vue';
import CopyText from '@/components/CopyText.vue';

// animations
import OrderCompleteAnimation from '@/assets/animations/animation-order-complete.json';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// vue
const Router = useRouter();

const GoHome = () => {
  Router.push({ path: '/' });

  window.scrollTo({ top: 0 });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(StepHeader, { Step: 4 }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "call-to-action-button no-animation",
                  onClick: GoHome
                }, [
                  _hoisted_8,
                  _createVNode(_component_font_awesome_icon, {
                    style: { color: '#fff' },
                    icon: ['fas', 'arrow-right']
                  })
                ])
              ]),
              _createVNode(_component_Vue3Lottie, {
                animationData: _unref(OrderCompleteAnimation),
                height: 300,
                width: 300,
                loop: false
              }, null, 8, ["animationData"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(StepBox),
        _createVNode(CopyText)
      ])
    ])
  ], 64))
}
}

})